import React from 'react';
import { connect } from 'react-redux';

import { Message, State } from '../types';

import MessageItem from './MessageItem/MessageItem';
import { messagesSelector } from '../selectors/messages';

import styles from './ConversationPane.module.css';

export function ConversationPane({ messages }: { messages: Array<Message> }) {
  return (
    <div className={styles.messagesContainer}>
      {messages.map(message => (
        <MessageItem key={message.id} message={message} />
      ))}
    </div>
  );
}

const mapState = (state: State) => {
  return {
    messages: messagesSelector(state),
  };
};

export default connect(mapState)(ConversationPane);
